module.exports = __webpack_public_path__ + "img/sundashboard.1a935722.png";